let initPhotoSwipeFromDOM = function(gallerySelector) {
    let items = [];

    let parseThumbnailElements = function(el) {
        let size = el.getAttribute('data-size').split('x');
        let item = {
            src: el.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
        };

        item.msrc = el.children[0].getAttribute('src');

        items.push(item);

        return items;
    };

    // triggers when user clicks on thumbnail
    let onThumbnailsClick = function(el) {
        let index = parseInt(el.getAttribute('data-pswp-uid') || 1) - 1;

        if (index >= 0) {
            openPhotoSwipe(index, el, true);
        }

        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    let photoswipeParseHash = function() {
        let hash = window.location.hash.substring(1),
            params = {};

        if (hash.length < 5) {
            return params;
        }

        let vars = hash.split('&');
        for (let i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            let pair = vars[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    let openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        let pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options;

        // define options (if needed)
        options = {
            shareEl: false,
            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            /*getThumbBoundsFn: function () {
                // See Options -> getThumbBoundsFn section of documentation for more info
                let thumbnail   = galleryElement.getElementsByTagName('img')[0],
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect        = thumbnail.getBoundingClientRect();

                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            }*/

        };

        // PhotoSwipe opened from URL
        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for(let j = 0; j < items.length; j++) {
                    if(items[j].pid === index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
            return;
        }

        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    let galleryElements = document.querySelectorAll( gallerySelector );

    for (let i = 0, l = galleryElements.length; i < l; i++) {
        parseThumbnailElements(galleryElements[i]);
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].addEventListener('click', function (e) {
            e.preventDefault();
            onThumbnailsClick(galleryElements[i]);
        });
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    let hashData = photoswipeParseHash();
    if(hashData.pid && hashData.gid) {
        openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
    }
};

// execute above function
initPhotoSwipeFromDOM('.js-photoswipe-gallery');
